export const COPY_LOGIN_TITLE = "Login to your Ahauz";
export const COPY_LOGIN_SUBMIT = "Login";
export const COPY_LOGIN_SUCCESS_TITLE = "Login success!";
